import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Button from '../Button/index.esm.js';
import ModalBody from '../Modal/ModalBody/index.esm.js';
import ModalContent from '../Modal/ModalContent/index.esm.js';
import ModalFooter from '../Modal/ModalFooter/index.esm.js';
import ModalHeader from '../Modal/ModalHeader/index.esm.js';
import ModalOverlay from '../Modal/ModalOverlay/index.esm.js';
import ModalTitle from '../Modal/ModalTitle/index.esm.js';
import Modal from '../Modal/index.esm.js';

var AlertDialog = function AlertDialog(props) {
  var title = props.title,
      description = props.description,
      open = props.open,
      onClose = props.onClose,
      onConfirm = props.onConfirm,
      _props$confirmLabel = props.confirmLabel,
      confirmLabel = _props$confirmLabel === void 0 ? 'Confirm' : _props$confirmLabel,
      _props$closeLabel = props.closeLabel,
      closeLabel = _props$closeLabel === void 0 ? onConfirm ? 'Cancel' : 'OK' : _props$closeLabel,
      _props$destructive = props.destructive,
      destructive = _props$destructive === void 0 ? false : _props$destructive,
      _props$size = props.size,
      size = _props$size === void 0 ? 'max-w-xs' : _props$size,
      rest = _objectWithoutPropertiesLoose(props, ["title", "description", "open", "onClose", "onConfirm", "confirmLabel", "closeLabel", "destructive", "size"]);

  var closeRef = React__default.useRef(null);
  return React__default.createElement(Modal, _extends({
    open: open,
    onClose: onClose,
    initialFocusRef: closeRef,
    size: size
  }, rest), React__default.createElement(ModalOverlay, null), React__default.createElement(ModalContent, {
    role: "alertdialog"
  }, React__default.createElement(ModalHeader, null, React__default.createElement(ModalTitle, {
    textAlign: "text-center"
  }, title)), React__default.createElement(ModalBody, {
    textAlign: "text-center"
  }, description), React__default.createElement(ModalFooter, null, onConfirm && React__default.createElement(Button, {
    appearance: destructive ? 'danger' : 'primary',
    onClick: onConfirm
  }, confirmLabel), React__default.createElement(Button, {
    onClick: onClose,
    ref: closeRef
  }, closeLabel))));
};

export default AlertDialog;
//# sourceMappingURL=index.esm.js.map
